
/*
* Title Case
* */
const utility = {
    toTitleCase(str) {
        return str.replace(/\w\S*/g, function(txt){
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    },

    toHyphenCase(str){
        return str.replace(/([^\W_]+[^\s-]*) */g, function(txt){
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    },

    bodyTypeLetter(str){
        if(!str){
            return '';
        }

        let returnStr = '';
        let splitStr = str.split('-');

        for(let i = 0, len = splitStr.length-1; i <= len; i++){
            returnStr += splitStr[i][0];
        }

        return returnStr.toUpperCase();
    }
};

export default utility;


// WEBPACK FOOTER //
// ./src/utility/utility.js